import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from 'react';

import { StorageProvider } from '@gogame/screens';
import isEqual from 'lodash/isEqual';

import {
  useLoadUserSettings,
  useSaveUserSettings,
} from 'scenes/HomeDashboard/hooks';
import { screenSchema } from 'scenes/HomeDashboard/schemas';

const mapScreenStateToInitialState = (screenState) =>
  screenSchema.stripDefaults().cast(screenState, {
    applyConst: true,
    stripUnknown: true,
  });

const mapInitialStateToScreenState = (data) =>
  screenSchema.cast(data, {
    parseConst: true,
  });

const HomeDashboardStorage = ({ children }) => {
  const [initialState, setInitialState] = useState();
  const _initialStateRef = useRef(null);

  if (!_initialStateRef.current && initialState) {
    _initialStateRef.current = initialState;
  }

  const loadUserSettings = useLoadUserSettings();
  const saveUserSettings = useSaveUserSettings();

  const loadData = async () => {
    const data = await loadUserSettings();
    if (data) {
      setInitialState(data);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const state = useMemo(() => {
    return mapInitialStateToScreenState(initialState);
  }, [initialState]);

  const handleSave = useCallback((data) => {
    const nextInitialState = mapScreenStateToInitialState(data);

    if (!isEqual(nextInitialState, _initialStateRef.current)) {
      const backUpstate = _initialStateRef.current;
      _initialStateRef.current = nextInitialState;
      saveUserSettings(nextInitialState).catch(() => {
        if (_initialStateRef.current === nextInitialState) {
          _initialStateRef.current = backUpstate;
        }
      });
    }
  }, []);

  return (
    <StorageProvider state={state} onSave={handleSave}>
      {children}
    </StorageProvider>
  );
};

export default HomeDashboardStorage;
